import { render, staticRenderFns } from "./main-mobile-edit.vue?vue&type=template&id=797bb138&lang=pug&"
import script from "./main-mobile-edit.vue?vue&type=script&lang=js&"
export * from "./main-mobile-edit.vue?vue&type=script&lang=js&"
import style0 from "./main-mobile-edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports